<template>
  <div>
    <div class="tw-text-gray-800">
      Comment
      <base-badge v-if="event.isMerge == true" class="tw-ml-2" size="sm" color="gray">Merged</base-badge>
    </div>
    <div class="tw-mt-0.5 tw-text-xs tw-text-gray-500">
      {{ event.label }}
    </div>
    <base-button type="text" size="xs" @click="$emit('editComment', event)">Edit / Delete</base-button>
  </div>
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
};
</script>
